import React from 'react';
import {Routes, Route} from 'react-router-dom';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import SuperAdminLogin from './pages/SuperAdminLogin';
import CompanyManagement from './pages/CompanyManagement';
import SalesManagement from './pages/SalesManagement';
import PricingManagement from './pages/PricingManagement';
import SystemSettings from './pages/SystemSettings';
import CorporateOverview from './pages/CorporateOverview';
import DepartmentDashboard from './pages/DepartmentDashboard';
import UserManagement from './pages/UserManagement';
import InternalStaffManagement from './pages/InternalStaffManagement';
import ExternalServicesManagement from './pages/ExternalServicesManagement';
import PartnerManagement from './pages/PartnerManagement';
import SupportTicketManagement from './pages/SupportTicketManagement';
import SystemAnalytics from './pages/SystemAnalytics';
import ExternalWhistleblowerHandling from './pages/ExternalWhistleblowerHandling';
import GuideManagement from './pages/GuideManagement';
import InvoiceManager from './pages/InvoiceManager';
import SuperAdminMessages from './pages/SuperAdminMessages';
import BookingOverview from './pages/BookingOverview';
import UtrederDirectory from './pages/UtrederDirectory';
import CategoryManagement from './pages/CategoryManagement';
import ReportingModule from './pages/ReportingModule';
import CourseInterestList from './pages/CourseInterestList';

const SuperAdminModule=()=> {
return ( 
<Routes> 
  <Route path="/" element={<SuperAdminDashboard />} /> 
  <Route path="login" element={<SuperAdminLogin />} /> 
  <Route path="companies" element={<CompanyManagement />} /> 
  <Route path="sales" element={<SalesManagement />} /> 
  <Route path="partners" element={<PartnerManagement />} /> 
  <Route path="pricing" element={<PricingManagement />} /> 
  <Route path="system-settings" element={<SystemSettings />} /> 
  <Route path="support-tickets" element={<SupportTicketManagement />} /> 
  <Route path="external-handling" element={<ExternalWhistleblowerHandling />} /> 
  <Route path="corporate" element={<CorporateOverview />} /> 
  <Route path="department/:id" element={<DepartmentDashboard />} /> 
  <Route path="users" element={<UserManagement />} /> 
  <Route path="internal-staff" element={<InternalStaffManagement />} /> 
  <Route path="external-services" element={<ExternalServicesManagement />} /> 
  <Route path="analytics" element={<SystemAnalytics />} /> 
  <Route path="guides" element={<GuideManagement />} /> 
  <Route path="invoices" element={<InvoiceManager />} /> 
  <Route path="messages" element={<SuperAdminMessages />} /> 
  <Route path="bookings" element={<BookingOverview />} /> 
  <Route path="utredere" element={<UtrederDirectory />} /> 
  <Route path="course-leads" element={<CourseInterestList />} />
  <Route path="categories" element={<CategoryManagement />} /> 
  <Route path="reporting" element={<ReportingModule />} />
</Routes> 
);
};
export default SuperAdminModule;